import { useState } from "react";

import { useAuthContext } from "shared/utils/hooks/useAuthContext";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import Modal from "../Modal";

export default function RenderModal({ render }) {
  const [visible, setVisible] = useState(false);
  const { setState } = useGlobalContext();
  const { loggedUser } = useAuthContext();

  const handleVisible = () => {
    if (!loggedUser) {
      return setState((prev) => ({
        ...prev,
        modal: {
          ...prev.modal,
          open: true,
          page: "login",
        },
      }));
    }

    setVisible(!visible);
  };

  return (
    <div>
      {render({ visible, handleVisible })}
      {visible && loggedUser && (
        <Modal visible={visible} handleVisible={handleVisible} />
      )}
    </div>
  );
}
